import { BehaviorParameters } from 'rangeConfig/@types';
import { ProductType } from '@inter-ikea-storageone/range';
import { deleteUncoupledSlidingDoors } from '@inter-ikea-storageone/range-platsa';

const deleteFront = ({ coreApi }: BehaviorParameters) => {
  const selectedEntity = coreApi.entities.findSelectedEntity();

  if (!selectedEntity) return;

  const selectedProductType = coreApi.entities.getProductType(selectedEntity);

  if (selectedProductType === ProductType.PLATSA_SLIDING_DOOR_ASM) {
    coreApi.entities.delete(selectedEntity);
    deleteUncoupledSlidingDoors(coreApi);
  } else {
    coreApi.entities.delete(selectedEntity);
  }
};

export default deleteFront;
